import { api } from '../app/api.js';
import { sanitise } from "../helpers/sanitiser.js";

export default {
    template: `
        <div class="section darker fh">
            <div class="content legal">
              <h1>Privacy Policy</h1>
              <p id="privacy-loading">Loading...</p>
              <p id="privacy-error" class="terms-error center"></p>
              <p id="privacy-meta" class="dark"></p>
              <div id="privacy-content" style="display: none;"></div>
            </div>
        </div>
    `,

    $loading: null,
    $errors: null,
    $content: null,
    $meta: null,

    async onMount() {
        this.$loading = document.getElementById('privacy-loading');
        this.$errors = document.getElementById('privacy-error');
        this.$content = document.getElementById('privacy-content');
        this.$meta = document.getElementById('privacy-meta');

        this.load_policy();
    },

    async load_policy() {
        this.$loading.style.display = 'block';
        this.$errors.style.display = 'none';
        this.$content.style.display = 'none';

        api.get({
            url: '/legal/privacy',
            success: response => {
                const date = new Date(response.date_created * 1000);

                this.$content.innerHTML = sanitise(response.description);
                this.$meta.textContent = `Version ${response.version} — Created on ${date.toLocaleDateString()}`;

                this.$loading.style.display = 'none';
                this.$content.style.display = 'block';
            },
            error: () => {
                this.$errors.textContent = 'Failed to load privacy policy. Please try again later.';
                this.$loading.style.display = 'none';
                this.$errors.style.display = 'block';
            }
        })
    }
};
